import { render, staticRenderFns } from "./TableEffectB.vue?vue&type=template&id=dedd5d38&scoped=true"
import script from "./TableEffectB.vue?vue&type=script&lang=js"
export * from "./TableEffectB.vue?vue&type=script&lang=js"
import style0 from "./TableEffectB.vue?vue&type=style&index=0&id=dedd5d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedd5d38",
  null
  
)

export default component.exports